import { ButtonAppearance, Button, Box, SideSheetClose, ButtonSize } from '@bechtel/gds';
import { Scalars } from '@bechtel/types';
import styled, { css } from 'styled-components';

interface WeldStyledProps {
  isOneWeldSelected: Scalars['Boolean'];
}
export const RodRequestFooterButtonStyled = styled(Button).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;

export const FillerMaterialStyled = styled.div`
  ${({ theme }) => css`
    margin-left: ${theme.spacings[400]};
    margin-right: ${theme.spacings[400]};
    justify-content: center;
    display: grid;
    grid-template-columns: 10% 45% 35% 10%;
    border-bottom: 1px solid ${theme.colors.grey[300]};
  `}
`;
export const RodRequestSideSheetSubHeaderStyled = styled(Box).attrs({
  py: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    background-color: ${theme.colors.bechtel.blue[100]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `}
`;

export const AddNewButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
  appearance: ButtonAppearance.TERTIARY,
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    color: ${theme.colors.black};
    padding-left: ${theme.spacings[450]};
    padding-right: ${theme.spacings[450]};
    margin-left: ${theme.spacings[450]};
    width: auto;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `}
`;

export const ListSelectionStyled = styled(Box).attrs({ p: { sm: '500' }, alignItems: { sm: 'center' } })`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
`;

export const ClosedStyled = styled(SideSheetClose)`
  ${({ theme }) =>
    css`
      margin-right: ${theme.spacings[500]};
    `}
`;

export const WeldStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})<WeldStyledProps>`
  ${(props) =>
    props.isOneWeldSelected &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
      background-color: ${({ theme }) => theme.colors.bechtel.blue[100]};
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    `}
  position:relative;
`;
